export default "__VITE_ASSET__yoAZHJX$__"